import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateDiscountComponent } from './create-discount/create-discount.component';
import { DiscountListComponent } from './discount-list/discount-list.component';
import { EditDiscountComponent } from './edit-discount/edit-discount.component';
import { ViewDiscountComponent } from './view-discount/view-discount.component';

const routes: Routes = [
  {
    path: '',
    children: [
    {
      path:'discount-list' , component:DiscountListComponent,
      data: {
        title: 'Discount List Page'
      }
    },
    {
      path:'create-discount' , component:CreateDiscountComponent,
      data: {
        title: 'Discount Create Page'
      }
    },
    {
      path:'discount-edit/:id' , component:EditDiscountComponent,
      data: {
        title: 'Discount Edit Page'
      }
    },
    {
      path:'discount-view/:id' , component:ViewDiscountComponent,
      data: {
        title: 'Discount View Page'
      }
    },
  ]
}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DiscountRoutingModule { }
